/**
 * shards-vue d-popover/d-tooltip MutationObserver calls _TPInstance.update(),
 * but the bundled TPManager only exposes updateConfig / Popper scheduleUpdate.
 * Without this patch, dynamic slot content (e.g. word lists) throws on the
 * second content change: "this._TPInstance.update is not a function".
 */
function resolveComponentOptions(Ctor) {
  if (!Ctor) {
    return null;
  }
  if (Ctor.options && Ctor.options.methods) {
    return Ctor.options;
  }
  if (Ctor.methods) {
    return Ctor;
  }
  return null;
}

function safeUpdatePosition() {
  const instance = this._TPInstance;
  if (!instance) {
    return;
  }

  if (typeof instance.update === 'function') {
    instance.update();
    return;
  }

  const popper = instance._popperInstance;
  if (popper && typeof popper.scheduleUpdate === 'function') {
    popper.scheduleUpdate();
  }
}

export default function patchShardsToolpopUpdate(Vue) {
  // shards-vue registers as dPopover / dTooltip (Vue.component keys).
  ['dPopover', 'dTooltip', 'd-popover', 'd-tooltip'].forEach(name => {
    const options = resolveComponentOptions(Vue.options.components[name]);
    if (!options || typeof options.methods._updatePosition !== 'function') {
      return;
    }

    options.methods._updatePosition = safeUpdatePosition;
  });
}
